module.exports = {
    videoSettings: {
        truebeauty: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/5in1.mp4'
        },
        zeitgard: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/zeitgard_erklaerung.mp4'
        },
        nightmaster: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/nightmaster.mp4'
        },
        cannaloe: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/cannaloe.mp4'
        },
        mens_shot: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/mens_shot.mp4'
        },
        cell_essence: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/Cell-Essence_Launchfilm_lang.mp4'
        },
        aromatherapie: {
            backDestinationName: 'root',
            backDestinationParam: '',
            videoPath: 'data/videos/SoN_Launchfilm_1080_DE.mp4'
        },
    }
}